<boi-validation-error-generic [validationErrors]="validationErrors" [propertyNames]="validationPropertyNames">
</boi-validation-error-generic>
<div [ngClass]="cssClasses" class="field-container">
    <div *ngIf="labelName" [boiRequiredFormField]="required ? labelName : undefined" 
        class="field-label">
        <label [innerHtml]="labelName | localizeLabel"></label>
    </div>
    <div class="field-input">
        <div [id]="controlId ? controlId : labelName" *ngFor="let option of selectableOptions; let i = index">
            <boi-checkbox [controlId]="controlId ? (controlId + i) : (labelName + i)" [ngModel]="option.Selected"
                (ngModelChange)="handleCheckEvent(option)" [isFieldDisabled]="isFieldDisabled"
                [checkboxLabel]="option.Value">
            </boi-checkbox>
        </div>
    </div>
    <boi-tooltip [tooltipName]="tooltipName ? tooltipName : labelName"></boi-tooltip>
</div>